export const theme = {
  colors: {
    primary: "#1a73e8",
    secondary: "#34a853",
    tertiary: "#f9ab00",
    danger: "#ea4335",
    success: "#00a762",
    background: "#f8fafb",
  },
  text: {
    primary: "#202124",
    secondary: "#5f6368",
    light: "#80868b",
  },
  cards: {
    base: {
      background: "#ffffff",
      borderRadius: "12px",
      border: "1px solid #e8eaed",
      boxShadow: "0 2px 6px rgba(60,64,67,0.15)",
      transition: "transform 0.2s ease, box-shadow 0.2s ease",
      "&:hover": {
        transform: "translateY(-2px)",
        boxShadow: "0 4px 12px rgba(60,64,67,0.2)",
      },
    },
    statsContainer: {
      margin: "16px 0",
      padding: "12px",
      background: "#f8f9fa",
      borderRadius: "8px",
    },
  },
  table: {
    header: {
      backgroundColor: "#f8fafb",
      color: "#202124",
      fontWeight: "500",
      fontSize: "13px",
      padding: "16px 12px",
      borderBottom: "1px solid #e8eaed",
      position: "sticky",
      top: 0,
      zIndex: 1,
    },
    cell: {
      padding: "12px",
      fontSize: "13px",
      color: "#5f6368",
      borderBottom: "1px solid #e8eaed",
      verticalAlign: "top",
      textAlign: "center",
    },
    dealerCell: {
      padding: "12px",
      fontSize: "13px",
      color: "#5f6368",
      borderBottom: "1px solid #e8eaed",
      verticalAlign: "top",
      whiteSpace: "pre-wrap",
      lineHeight: "2",
      textAlign: "center",
    },
  },
  map: {
    container: {
      height: "600px",
      width: "100%",
      position: "relative",
      zIndex: 0,
      borderRadius: "12px",
      overflow: "hidden",
      boxShadow: "0 2px 6px rgba(60,64,67,0.15)",
    },
  },
};
